module.exports = __webpack_public_path__ + "prod/1.42.2/media/bank.d3373c03.mp4";